import { useState } from 'react';

import getConfig from '../../../util/config';
import getLogger from '../../../util/logger';
import logoutFromApi from '../../../util/logout';

const log = getLogger('Logout Hook');
/**
 * Logout hook
 * */

const useLogout = () => {
  const [loading, setLoading] = useState(false);
  const config = getConfig();

  const logout = async ({ redirectUrl } = {}) => {
    if (loading) {
      return;
    }

    try {
      await logoutFromApi();

      if (window.location) {
        window.location = redirectUrl || config.app.baseUrl;
      }
    } catch (error) {
      log.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    logout,
  };
};

export default useLogout;
